export default __webpack_public_path__ + "static/media/trash.192f878c.svg";